import BaseRepository from './base.repository';

class BreakoutToolRepository extends BaseRepository {
  constructor() {
    super('breakout-tool');
  }

  /**
   * Lấy tất cả questions
   * @param {string|null} group - Group code để filter (ví dụ: 'C' cho Breakout)
   * @returns {Promise} { questions }
   */
  getAllQuestions(group = null) {
    const params = group ? { group } : {};
    return this.client.get('/questions', params);
  }

  /**
   * Lấy market overview (đèn giao thông)
   * @returns {Promise} Market overview data
   */
  getMarketOverview() {
    return this.client.get('/market-overview');
  }

  /**
   * Query stocks với filter
   * @param {Object} params - Filter parameters
   * @returns {Promise} { data, pagination }
   */
  queryStocks(params = {}) {
    return this.client.get('/stocks', params);
  }

  /**
   * Lấy patterns nến hôm nay
   * @param {Object} params - Filter parameters
   * @returns {Promise} Patterns list
   */
  getTodayPatterns(params = {}) {
    return this.client.get('/patterns', params);
  }

  /**
   * Lấy thống kê ngành
   * @returns {Promise} Industry statistics
   */
  getIndustryStats() {
    return this.client.get('/industries');
  }

  /**
   * Thực thi câu hỏi nhanh
   * @param {string} questionCode - Code của câu hỏi (ví dụ: C_BREAKOUT_TODAY)
   * @param {Object} options - { as_of, limit, offset }
   * @returns {Promise} { data, question, total }
   */
  executeQuestion(questionCode, options = {}) {
    return this.client.get(`/questions/${questionCode}/execute`, options);
  }

  /**
   * Lấy danh sách stocks trong watchlist của user
   * @returns {Promise} { data, total, title }
   */
  getWatchlistStocks() {
    return this.client.get('/watchlist');
  }
}

export default new BreakoutToolRepository();

